// extracted by mini-css-extract-plugin
module.exports = {"spin":"routing_spin__1WncC","loadingOutlined":"routing_loadingOutlined__HiZgS"};